////////
// Search
// ---------------
// @desc 		Search object that envelopes all search requests
// @param		<HTMLElement>
// @param		<Function> For results callback
////////
var Search = function(element, resultsCallback) {

	App.log("Search: [Init]");

	this.flags = {
		ACTIVE: "active"
	};

	this.callback = resultsCallback;
	this.cache = [];
	this.element = $(element);
	this.element.on("input", this, this.newQuery);
	this.timer = false;

	// Block form submission, all input based on key change
	this.form = this.element.parentsUntil("form");
	this.form.on("submit", function() {
		return(false);
	});

	// Private functions
	this._getUrlParameter = function(name) {
	    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	    var results = regex.exec(location.search);
	    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	// Get input value
	this._getInputValue = function() {
		return(this.element.val());
	}

	// Return from local cache
	this._getFromCache = function(q) {
		var results = this.cache.filter(function(item) {
			return item.query == q;
		});
		return(results);
	};


}

Search.prototype.newQuery = function(e, execute) {
	var obj = e.data;

	if(execute !== true) {
		// Not called by the timer, so wait
		// Check if timer already exists
		if(this.timer) {
			clearTimeout(this.timer);
		}
		this.timer = setTimeout(obj.newQuery, 1000, e, true);
		// Stop execution
		return;
	}

	// Get value from input field, not query string (as this will be pre-rendered via Twig input)
	var q = obj.getSearchValue();

	// If there's a value, execute
	if(q) {
		// Check if this search has been previously cached
		var cache = obj._getFromCache(q);
		if(cache.length > 0) {
			// If so, render based on local cache results
			App.log("Search: Cached query  — ", q);
			obj.parseResults(cache[0]);
		} else {
			// Otherwise go perform a new search
			App.log("Search: New query — ", q);
			obj.executeSearch(q);
		}
	}
}



Search.prototype.executeSearch = function(q) {
	// Set up our HTTP request
	var xhr = new XMLHttpRequest();
	var obj = this;
	// Setup our listener to process completed requests
	xhr.onload = function () {
		// Process our return data
		if (xhr.status >= 200 && xhr.status < 300) {
			// Runs when the request is successful
			obj.parseResults(xhr.responseText);

		} else {
			// Runs when it's not
			console.log("Search: Failed to get responses", JSON.parse(xhr.responseText));
		}
	};
	// Create and send a GET request
	xhr.open('GET', '/search.json?q=' + q);
	xhr.send();
}


Search.prototype.getSearchValue = function() {
	return(this._getInputValue());
}


Search.prototype.parseResults = function(data) {
	if(data.length > 1) {
		// Form data into JSON
		var json = JSON.parse(data).data;

		// Get the query value
		var q = this.getSearchValue();

		// Double check it's not in the cache, in case this is a cached response
		var fromCache = this._getFromCache(q);
		if(fromCache.length == 0) {
			// If not, cache it
			this.cache.push({
				query: q,
				// Store raw data string from XHR
				result: data
			});
		}

		// Pass results back
		this.callback(json, q);
	}
}
